import { Injectable, Inject } from '@angular/core';
import { Response } from '@angular/http';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { InspectionUnsyncedVwMdl } from '../../entities/inspection/model';
import { ResultMessage, UCSystem } from '../../entities';
import { catchError } from 'rxjs/operators';
import { ComponentFlaggedVM } from '../interpretation/models/interpretation.model';
@Injectable()
export class UCInspectionsService {
  constructor(private _http: HttpClient) {

    }
    private handleError(error: Response) {
        console.error(error);
        
        return Observable.throw(error.json().error || 'Server error');
    }

    public getUnSyncedInspection(Id: number): Observable<InspectionUnsyncedVwMdl> {
      let options = {
        params: new HttpParams().set('Id', Id.toString())
      };
      return this._http.get<InspectionUnsyncedVwMdl>("Api/Inspection/GetUnsyncedInspection", options).pipe(catchError(this.handleError));
    }

    public GetEquipmentSystems(EquipmentId: number): Observable<UCSystem[]> {
      let options = {
        params: new HttpParams().set('EquipmentId', EquipmentId.toString())
      };
      return this._http.get<UCSystem[]>("Api/Equipment/getSystemList", options).pipe(catchError(this.handleError));
    }

    public matchEquipment(EquipmentId: number, MobileInspectionId: number, MobileEqId: number): Observable<ResultMessage> {
      return this._http.post<ResultMessage>("Api/Inspection/MatchEquipmentWithMobileEquipment", { EquipmentId: EquipmentId, MobileInspectionId: MobileInspectionId, MobileEqId: MobileEqId }).pipe(catchError(this.handleError));
    }

    public submitUnsynced(EquipmentId: number, MobileInspectionId: number, MobileEqId: number): Observable<ResultMessage> {
      return this._http.post<ResultMessage>("Api/Inspection/SubmitUnsyncedInspection", { EquipmentId: EquipmentId, MobileInspectionId: MobileInspectionId, MobileEqId: MobileEqId }).pipe(catchError(this.handleError));
    }

    public UpdateUnsyncedSMU( MobileInspectionId: number, SMU: number): Observable<any> {
      return this._http.post("Api/Inspection/UpadateUnsyncInspectionSMU", { MobileInspectionId: MobileInspectionId, SMU: SMU }).pipe(catchError(this.handleError));
    }
  public getMblFlaggedComponentDetail(unSyncedInspectionId: number, MblInspectionDetailId: number, ComponentId: number): Observable<ComponentFlaggedVM> {
    const options = {
      params: new HttpParams().set('MblInspectionDetailId', MblInspectionDetailId.toString())
        .set('ComponentId', ComponentId.toString())
        .set('unSyncedInspectionId', unSyncedInspectionId.toString())
    };
    return this._http.get<ComponentFlaggedVM>('api/interpretation/GetMblFlaggedComponentDetail', options).pipe(catchError(this.handleError));
  }
}
